export enum SourceType {
  MediaList = "MediaList",
}
